import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/login/login'
import Layout from '@/layout'

Vue.use(Router)

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */


export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/pages/login/login'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/slide/index',
    hidden: true
  },
  /* {
    path: '/home',
    name: 'home',
    component: Layout,
    meta: {
      icon: 'home',
      title: '首页'
    },
    hidden: true,
    redirect: '/home/index',
    children:
        [
          {
            meta: {
              affix: true,
              title: '首页'
            },
            copy: true,
            name: 'homeindex',
            path: 'index',
            component: () => import('@/pages/home/index')
          }
        ]
  }, */
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children:
        [
          {
            path: '/redirect/:path*',
            component: () => import('@/pages/redirect/index')
          }
        ]
  }
];
export const menusRoute = [{
  path: '/menus',
  name: 'menus',
  component: Layout,
  meta: {
    icon: 'menu',
    title: '菜单管理'
  },
  redirect: '/menus/index',
  children:
      [
        {
          meta: {
            title: '菜单管理'
          },
          copy: true,
          name: 'menusindex',
          path: 'index',
          component: () => import('@/pages/menus/index')
        }
      ]
}];

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({y: 0}),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js